import { TrendingListSidebar } from "../../../../components/TrendingList";
import { SECTIONS } from "../../../../constants/sections";

/**
 * This function handles creating a trending list widget
 *
 * @param {Object} params the widget params
 *
 * @returns {JSX} component structure for trending list widget
 */

const TrendingContainer = ({ params }) => {
    const section = params.trending?.category.replace(/trending-\/?/, "");
    const trendingHeading = SECTIONS[section]?.trendingSidebarLabel || null;

    return (
        <TrendingListSidebar
            section={section}
            trendingHeaderOverride={trendingHeading}
        />
    );
};

export default TrendingContainer;
